(function(){
  if (window.jQuery && jQuery.fn && jQuery.fn.load) {
    var origLoad = jQuery.fn.load;
    jQuery.fn.load = function(a){
      if (typeof a === 'function') {
        return this.on('load', a);
      }
      return origLoad.apply(this, arguments);
    };
  }
})();
